import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-refresh-platform-verification-code-modal',
  templateUrl: './refresh-platform-verification-code-modal.component.html',
  styleUrls: ['./refresh-platform-verification-code-modal.component.scss'],
})
export class RefreshPlatformVerificationCodeModalComponent {
  constructor(
    private dialogRef: MatDialogRef<RefreshPlatformVerificationCodeModalComponent>
  ) {
    if (this.timeout > 0) {
      let interval = setInterval(async () => {
        this.timeout -= 1;
        if (this.timeout === 0) {
          this.disabled = false;
          clearInterval(interval);
        }
      }, 1000);
    }
  }

  close() {
    this.dialogRef.close();
  }

  timeout = 5;
  disabled = true;

  onOk() {
    if (!this.disabled) this.dialogRef.close('ok');
  }
}
